import { render, staticRenderFns } from "./uploaduser.vue?vue&type=template&id=36bfc4de&scoped=true&"
import script from "./uploaduser.vue?vue&type=script&lang=js&"
export * from "./uploaduser.vue?vue&type=script&lang=js&"
import style0 from "./uploaduser.vue?vue&type=style&index=0&id=36bfc4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bfc4de",
  null
  
)

export default component.exports